import { isAddedSource, kitAssetSourceOf } from 'fym-shared/src/music24/addedAssets';
import type { AssetViewerItem } from './viewerItems';

/**
 * What the viewer offers to make the next revision of the file on its stage (Releases v2, design d1):
 * - `newRevision`: "New revision" (the dialog d3). Every made kit asset and every AI reel.
 * - `editVideo`: "Edit the video" for a music video made by Music24. The editor makes its next
 *   version from a cut, so it opens with the cut that made this file (none for an old one: the
 *   newest cut).
 * - `none`: an added version (an upload or a YouTube link of the artist, `origin: 'added'`) of any
 *   asset type. Music24 did not make it, so it cannot make it again.
 * Pure.
 */
export type ViewerRevisionAction =
  | { kind: 'newRevision' }
  | { kind: 'editVideo'; cutUuid: string | null }
  | { kind: 'none' };

export function viewerRevisionAction(item: Pick<AssetViewerItem, 'themeId' | 'asset'>): ViewerRevisionAction {
  const { asset } = item;
  if (
    asset !== null &&
    (asset.origin === 'added' || asset.params.added === true || isAddedSource(kitAssetSourceOf(asset.source)))
  ) {
    return { kind: 'none' };
  }
  if (item.themeId === 'musicVideo') {
    return { kind: 'editVideo', cutUuid: asset?.params.musicVideoCutUuid ?? null };
  }
  return { kind: 'newRevision' };
}
